export const REQUEST = {
  AUTH: {
    GET_OTP: '/tokens/email/send',
    VERIFY_OTP: '/tokens/email/login',
    REFRESH: '/tokens/refresh',
    EXISTING_CUSTOMER: '/exc',
  },
  USER: {
    INFO: '/userInfo',
    INFO_ACCURACY: `/onboarding/info-accuracy`,
    INFO_REVIEW: `/onboarding/info-review`,
    DOCUMENT_AGREEMENT: '/onboarding/documentAgreement',
    CONSENT_DOCUMENTS: '/onboarding/consentDocuments',
    BIOMETRIC_CONSENT: '/onboarding/biometricConsent',
    PHONE_NUMBER: '/userInfo/phoneNumber',
    BRANCH: '/userInfo/branch',
    VALIDATE_USERNAME: '/userInfo/validateUsername',
    REQUIRED_DOCUMENTS: `/onboarding/requiredDocuments`,
    LANGUAGE: '/onboarding/language',
    TERMS_AND_CONDITIONS: '/onboarding/termsAndConditions',
    ACCOUNT_TYPE_ORDER_SELECT: '/onboarding/account-selection',
    CHARGE_ACCOUNT: '/onboarding/charge-account',
    NEW_OPERATION: '/onboarding/newOperation',
    CONFIRM_PERSONAL_DETAILS: '/onboarding/confirmPersonalDetails',
  },
  VERIFICATION: {
    ADD_DOC: '/onboarding/documents',
    INIT_IDMISSION_SESSION: '/onboarding/idmission/session',
    PROCESS_IDMISSION_RESULT: '/onboarding/idmission/processedData',
    IDENTITY_IMAGE: '/onboarding/idmission/identityImage',
  },
  PEP: {
    QUESTIONS: '/pep/questions',
    QUESTION_BY_ANSWER_ID: (id: string) => `/pep/questions/${id}`,
  },
  ACCOUNT: {
    TYPES: '/onboarding/accountTypes',
    TYPES_BATCH: '/onboarding/accountTypes/batch',
    DEPOSIT_INFO: '/onboarding/accountTypes/deposit-info',
  },
  DOCUMENT: {
    ROOT: '/onboarding/documents',
    DOWNLOAD_BY_S3: '/documents/downloadS3Object',
    CONFIRM_INFO: '/documents',
  },
  FINANCIAL_INFO: '/financial-info',
  SIGNING_DOCUMENTS: 'onboarding/docSignForms',
  ADD_SIGN_DOCUMENT: 'onboarding/docSigns',
  DOWNLOAD_TEMPLATE: {
    CONFIRMATION_OF_ADDRESS: '/onboarding/confirmationOfAddress',
    SELF_ATTESTATION_INCOME: '/onboarding/selfAttestationIncome',
    SELF_ATTESTATION_ADDRESS: '/onboarding/selfAttestationProofOfAddress',
    AUTHORIZATION_LETTER_FROM_UTILITY_BILL_NON_OWNER_EN:
      '/onboarding/downloadTemplate/Utility_Bill_Letter_of_Authorization.docx',
    AUTHORIZATION_LETTER_FROM_UTILITY_BILL_NON_OWNER_NL:
      '/onboarding/downloadTemplate/LETTER_UNITILTY_NED.docx',
    AUTHORIZATION_LETTER_FROM_UTILITY_BILL_NON_OWNER_EN_CYM:
      '/onboarding/downloadTemplate/CNB_Address_Confirmation_Form_v1.pdf',
    SELF_ATTESTATION_INCOME_EN_SUR:
      '/onboarding/downloadTemplate/Self_Attestation_Income_sur.docx',
    SELF_ATTESTATION_INCOME_NL_SUR:
      '/onboarding/downloadTemplate/Self_Attestation_Income_sur_nl.docx',
    MONTHLY_INCOME_AND_EXPENDITURE:
      '/onboarding/statementOfIncomeAndExpenditure',
    SELF_EMPLOYED_INCOME_VERIFICATION:
      '/onboarding/selfEmployedIncomeVerification?fileName=Self_Employed_Income_Verification_Form',
  },
  FEATURE: {
    ROOT: '/features',
  },
  OPERATION: {
    APPLICATION_TYPE: (operationId?: string) =>
      `/operations/${operationId ?? '-1'}/application-type`,
    ADD_ADULT_DETAIL: (operationId: string) =>
      `/operations/${operationId}/holders`,
    ADD_ADULT_CONTACT: (operationId: string) =>
      `/operations/${operationId}/rightstart-adult-email`,
    ADULT_PICKUP_CONFIRM: (operationId: string) =>
      `/operations/${operationId}/adult-pickup`,
    GET_LIST_HOLDERS_ID: (operationId: string) =>
      `/operations/${operationId}/holders`,
    GET_HOLDER_DETAIL: (operationId: string, holderId: number) =>
      `/operations/${operationId}/holders/${holderId}`,
    GET_HOLDER_REQUIRED_DOCUMENTS: (operationId: string, holderId: number) =>
      `/operations/${operationId}/holders/${holderId}/requiredDocuments`,
    ADULT_CONFIRM_KYC: (operationId: string, clientId: number) =>
      `/operations/${operationId}/holders/${clientId}/adult-confirm-kyc`,
    CONFIRM_INFO_ACCURACY: (operationId: string, clientId: number) =>
      `/operations/${operationId}/holders/${clientId}/info-accuracy`,
    UPDATE_HOLDER: (operationId: string, holderId: string) =>
      `/operations/${operationId}/holders/${holderId}`,
    ADULT_ALLOW_FOR_MINOR: (operationId: string, minorClientId: string) =>
      `/operations/${operationId}/holders/${minorClientId}/adult-allow-for-minor`,
    ADULT_PEP_FOR_MINOR: (operationId: string, minorClientId: string) =>
      `/operations/${operationId}/holders/${minorClientId}/adult-pep-for-minor`,
    ADULT_MINOR_RELATIONSHIP: (operationId: string, minorClientId: string) =>
      `/operations/${operationId}/holders/${minorClientId}/adult-relationship-for-minor`,
    SUPPORTING_LETTER: (operationId: string, minorClientId: string | number) =>
      `/operations/${operationId}/holders/${minorClientId}/supporting-letter`,
    SET_ADDRESS_SAME_AS_ADULT: (
      operationId: string,
      minorId: string | number,
      type?: string,
    ) => {
      const base = `/operations/${operationId}/holders/${minorId}/address/same-as-adult`;
      return type ? `${base}?type=${type}` : base;
    },
    CANCEL: (operationId: string) => `/operations/${operationId}/cancel`,
  },
  TERRITORIES: `/territories`,
  EMPLOYMENT: {
    ROOT: '/employment',
    OCCUPATIONS: 'employment/occupations',
    BUSINESS_CATEGORIES: 'employment/business-categories',
    UPDATE_EMPLOYMENT: (operationId: string | number) =>
      `/employment/operation/${operationId}`,
  },
  TAX_INFO: {
    ROOT: '/tax-info',
  },
  VENDOR: {
    PLACES: {
      DETAILS: (placeId: string) =>
        `https://places.googleapis.com/v1/places/${placeId}`,
    },
  },
  REMEDIATION: {
    DEPOSIT_INFO: '/remediation/accountTypes/deposit-info',
  },
};

export const ERROR_CODE = {
  PHONE_NUMBER_2_EXISTS: 'error.phoneNumber2.exists',
  AGE_UNDER_18: 'user.restricted.ageunder18',
  MINOR_AGE_OVER_18: 'user.restricted.joint_minor_over_18',
  NON_RESIDENT_MINOR_REJECTED: 'user.restricted.joint_minor_non_resident',
  ADDRESS_NOT_CAYMAN: 'user.restricted.addressnotcym',
  THIRD_PARTY_COMPLIANCE_PEP_YES: 'user.restricted.3rd_pep_yes',
  EXC_IS_NOT_ALLOWED: 'login.email.error.exc',
  EXC_PRE_APPROVED_STATUS_IS_NOT_ALLOWED: 'ex-customer-pre-approved',
  ADULT_UNDER_18: 'onboarding.add_holder.adult_under_18',
  JOINT_ADULT_UNDER_18: 'user.restricted.joint_adult_under_18',
  MINOR_TRIGGER_BY_ADULT_NOT_ALLOWED:
    'login.email.error.rs_minor_triggered_by_adult',
  DOCUMENT_SECURITY_VIOLATION: 'document-security-violation',
};

export const ERROR_MESSAGE = {
  EXC_IS_NOT_ALLOWED: 'ExCustomer is not allowed to login with email',
};

export const SYSTEM_SESSION_TIMEOUT_MESSAGE =
  'System timeout, please login again';
export const TOKEN_TYPE_BEARER = 'Bearer';
